import { Spinner } from "@jobber/components/Spinner";
import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { facebookAuthorize, getFacebookPages, saveFacebookPage } from "services";

const FacebookCallback = () => {
    const [searchParams] = useSearchParams();
    const code = searchParams.get("code");
    const state = searchParams.get("state");
    const navigate = useNavigate();

    useEffect(() => {
        if (!code || !state) {
            navigate("/error", { replace: true });
            return;
        }

        (async () => {
            try {
                const res = await facebookAuthorize(code, state);
                const newState = res.state;
                sessionStorage.setItem('state', newState);

                const pages = await getFacebookPages(newState);
                if (pages.length === 0) {
                    navigate("/jobber-facebook-step1", { replace: true, state: { error: "No Facebook Pages found — please reconnect and grant access to at least one Page." } });
                } else if (pages.length === 1) {
                    await saveFacebookPage(newState, pages[0]);
                    sessionStorage.setItem("selected_page_name", pages[0].name);
                    navigate("/jobber-facebook-step3", { replace: true });
                } else {
                    navigate("/jobber-facebook-step2", { replace: true });
                }
            } catch (e: any) {
                navigate("/jobber-facebook-step1", { replace: true, state: { error: e.message } });
            }
        })();
    }, []);

    return (
        <div
            style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                height: "100%",
            }}
        >
            <Spinner />
            <h1>Facebook authentication in progress</h1>
        </div>
    );
};

export default FacebookCallback;
